import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { TestimonialsTop } from '../components/TestimonialsTop';
import { ProblemSection } from '../components/ProblemSection';
import { BikeStorySection } from '../components/BikeStorySection';
import { VisualMethods } from '../components/VisualMethods';
import { FiveVolumes } from '../components/FiveVolumes';
import { ThirtyDayPlan } from '../components/ThirtyDayPlan';
import { BonusesSection } from '../components/BonusesSection';
import { AcceleratorKit } from '../components/AcceleratorKit';
import { IsThisForYou } from '../components/IsThisForYou';
import { PricingSection } from '../components/PricingSection';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { TestimonialsBottom } from '../components/TestimonialsBottom';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { CostOfInaction } from '../components/CostOfInaction';
import { FinalPricingCTA } from '../components/FinalPricingCTA';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
import { SocialProofToast } from '../components/SocialProofToast';
export function Landing() {
  return <main className="min-h-screen bg-slate-50" data-id="element-358">
      <HeroSection data-id="element-359" />
      <TrustBar data-id="element-360" />
      <TestimonialsTop data-id="element-361" />
      <ProblemSection data-id="element-362" />
      <BikeStorySection data-id="element-363" />
      <VisualMethods data-id="element-364" />
      <FiveVolumes data-id="element-365" />
      <ThirtyDayPlan data-id="element-366" />
      <BonusesSection data-id="element-367" />
      <IsThisForYou data-id="element-368" />
      <PricingSection data-id="element-369" />
      <AcceleratorKit data-id="element-370" />
      <WhatsIncluded data-id="element-371" />
      <TestimonialsBottom data-id="element-372" />
      <GuaranteeSection data-id="element-373" />
      <FaqSection data-id="element-374" />
      <CostOfInaction data-id="element-375" />
      <FinalPricingCTA data-id="element-376" />
      <EmotionalClose data-id="element-377" />
      <Footer data-id="element-378" />
      <StickyCTA data-id="element-379" />
      <SocialProofToast data-id="element-380" />
    </main>;
}